var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var EllipseData = require('../../../svg/ellipseData.js');
var PathData = require('../../../svg/pathData.js');
var PathObjectData = require('../../../svg/pathObjectData.js');
var PathType = require('../../../svg/pathType.js');
var IPCRules = require('../ipcRules');
var DualRowPackageData = require('./dualRowPackageData.js');

var SotflData = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);
};

lib_core.inherit(SotflData, DualRowPackageData);
lib_core.JsonParser.registerClass(SotflData, "SotflData");

module.exports = SotflData;

SotflData.prototype.getPads = function(absolutePositions) {
    var self = this;
    var pads = [];

    //reset component
    self.component.reset();

    self.updateComponentCalculator(self.horizontalLeadToLeadSpanMin(), self.horizontalLeadToLeadSpanMax());

    var hPitch = self.component.C,
        vPitch = self.verticalPinPitch(),
        motif = self.getMotif(),
        leftPadCount = self.component.padsPerSide[0],
        rightPadCount = self.component.padsPerSide[1],
        totalPadCount = leftPadCount + rightPadCount,
        rowIdx,
        idx;

    //left pads
    for (idx = 0; idx < leftPadCount; idx++) {
        rowIdx = idx % leftPadCount;

        var pad = motif.clone();
        pad.move(new lib_geometry.Coord(-0.5 * hPitch, ((leftPadCount - 1) / 2 - rowIdx) * ((totalPadCount === 3 || totalPadCount === 4) ? 2 : 1) * vPitch));
        pads.push(pad);
    }

    //right pads
    for (idx = 0; idx < rightPadCount; idx++) {
        rowIdx = rightPadCount - 1 - idx % rightPadCount;

        var pad = motif.clone();
        pad.move(new lib_geometry.Coord(0.5 * hPitch, ((rightPadCount - 1) / 2 - rowIdx) * ((totalPadCount === 5 || totalPadCount === 4) ? 2 : 1) * vPitch));
        pads.push(pad);
    }

    self.updatePads(pads, absolutePositions);
    return pads;
};
